import React, { useState } from 'react'
import { useEffect, } from 'react';
import { useTranslation } from "react-i18next";
import { sliderSettingFive } from "../../../../shared/sliderSetting.js"
import { Footer } from '../../../common/footer/footer';
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import "../globalMainSearch/globalMainSearch.css";
import "../globalMainSearch/globalMainSearchresponsive.css";
import { baseURL } from '../../../../constants/applicationConstants';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { Loader } from '../../../common/loader/loader';
import {  onOfferClick } from '../../../../shared/helper';
import { InstitutionCardList } from '../../../common/institutionCardList/institutionCardList.jsx';
import ExpertCardJsx from "../../../common/expertCard/expertCard.jsx"
import { ProductCardList } from "../../../common/productCardList/productCardList.jsx";
import { OfferCardListJSX } from '../../../common/offerCardList/offerCardList';
import { HomeArticleCardJSX } from '../../../common/homeArticleCard/homeArticleCard'

const GlobalMainSearchJsx = (props) => {
    const location = useLocation(); // Hook to access the location object
    const history = useHistory();

    const { t } = useTranslation();
    useEffect(() => {

    }, [])

    const [searchedData, setSearchedData] = useState('');
    const [allOffersData, setAllOffersData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(true);
    const searchParams = new URLSearchParams(location.search);
    const decodedURL = searchParams.get('search') || ''; 

    // const queryString = location.search;
    // const paramName = 'search';
    // const regex = new RegExp(`[?&]${paramName}=([^&]*)`); // Matches ?param=value or &param=value
    // const match = queryString.match(regex);
    // let search = '';

    // if (match && match[1]) {        
    //     search = match[1];
    // }
    // console.log('dsd',decodedURL)   
    
    // const search = decodeURIComponent(decodedURL);
    const search = decodedURL;
    const activeInstitutes = allOffersData?.institutes?.filter(institute => institute.status === 'active');
    const activeExperts = allOffersData?.experts?.filter(experts => experts.status === 'active');

   


    useEffect(() => {
        setIsProcessing(true);
        if (search) {
            // setSearchedData(search);
            setSearchedData(decodeURIComponent(search));
            axios.get(`${baseURL}/search-content?keyword=${search}`)
                .then(res => {
                    setAllOffersData(res.data.data);
                    setIsProcessing(false);
                });
        } else {
            setIsProcessing(false); // Handle the case where there's no search value
            history.push("/");
        }
    }, [location.search, search, history]);  // Add `search` and `history` to dependencies
    
    useEffect(() => {
        if (allOffersData?.offers?.length === 0 && allOffersData?.products?.length === 0 && allOffersData?.institutes?.length === 0 && allOffersData?.experts?.length === 0 && allOffersData?.articles?.body?.length === 0) {
             
        }
    }, [allOffersData])
    useEffect(() => {
       
        window.scrollTo(0, 0);
      }, [])
    // Dependency array to re-run when search changes



    return (
        <>
            { 
                <section className="searchcustom container-rimib">
                    {allOffersData?.offers?.length>0 &&
                        <section className="exclusive searchtopproduct">
                      

                                <OfferCardListJSX
                                    SubCatTitle={`“${searchedData}” ${t("COMMON.INOFFERS")}`}
                                    isGlobleMainSearch={true}
                                    offerData={allOffersData?.offers}
                                    redirectUrl={`offers/${searchedData}`}
                                    isDescription={false}
                                    isSlider={true}
                                />

                           
                        </section>
                    }
                    {allOffersData?.experts?.length>0 &&
                        <section className="ourbest ourbestexpertsearch">
                            <div className="container">
                                <div className="ourbexttext ourbestmargin" >
                                    <h2>“{searchedData}” in Experts</h2>
                                </div>
                                <Slider {...sliderSettingFive}>
                                    {
                                        activeExperts?.map(data => {
                                            return <>
                                                <ExpertCardJsx data={data} CategoryID={data?.institutionCategoryId} />

                                            </>
                                        })
                                    }
                                </Slider>
                            </div>
                            <div className="showall  text-center">
                                <Link to={`/globalMainSearchExpert?search=${searchedData}`} className="showallbtn mt-2 mb-3">{t("COMMON.SHOWALL")}</Link>
                            </div>
                        </section>
                    }

{
                    allOffersData?.products?.length>0 && <ProductCardList
                        productData={allOffersData?.products}
                        isGlobleMainSearch={true}
                        searchText={`“${searchedData}” ${t("COMMON.INPRODUCTS")}`}
                        subCategoryLayout={false}
                        onProductImageClick={onOfferClick}
                        isCategorySubCategory={false}
                        isProductName={false}
                        isViewButton={false}
                        searchedData={searchedData}
                    />
            }
                    {activeInstitutes && activeInstitutes.length>0 &&
                        <InstitutionCardList searchedData={searchedData} search={search} activeInstitutes={activeInstitutes} />
                    }

                    {allOffersData?.articles?.body?.length>0 &&
                        <section className="searcharticle">
                            <h2>“{searchedData}” in Articles</h2>
                            <div className="container">
                                <div className="main-articles-box">
                                <div className="item1">
                                    {
                                        allOffersData?.articles?.body?.map(data => {
                                            return <>
                                                <HomeArticleCardJSX
                                                    blogslug={data?.slug}
                                                    blogimage={data?.image}
                                                    blogtitle={data?.title}
                                                    blogshort_content={data?.short_content}
                                                    blogcat={data?.cats?.[0].cat_name}
                                                />
                                            </>
                                        })
                                    }

                                </div>
                                </div>
                                <div className="showall text-center">
                                    <Link to={`/searchArticles?search=${search}`} className="showallbtn mt-3 mb-3">{t("COMMON.SHOWALL")}</Link>
                                </div>
                            </div>
                        </section>
                    }

                </section> 
                
            }
            {
                allOffersData?.offers?.length === 0 && allOffersData?.products?.length === 0 && allOffersData?.institutes?.length === 0 && allOffersData?.experts?.length === 0 && allOffersData?.articles?.body?.length === 0 && <h1 className="text-center mt-4 mb-4">{t("COMMON.NORECORDFOUND")}</h1>
            }

            {isProcessing && <Loader />}
            <Footer />

        </>

    );
};

export default GlobalMainSearchJsx;